<template>
    <transition name="slide-fade">
        <div v-if="show" class="fixed mx-auto bottom-0 w-100 md:w-1/3 bg-white text-center p-10 inset-x-0 border drop-shadow-sm">
            <p>We use cookies to ensure that we give you the best experience possible. If you continue, we assume that you are happy to receive cookies.
                <a class="underline" href="/privacy-policy">Learn more</a>
            </p>

            <button @click="setCookie" class="bg-brand-blue text-white mt-4 px-4 py-2">Accept and Close</button>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            show: false,
        };
    },
    mounted() {
        if (!this.checkCookie('cookie')) {
            this.show = true;
        }
    },
    methods: {
        setCookie() {
            const date = new Date();
            date.setDate(date.getDate() + 30);
            document.cookie = `cookie=1; expires=${date}; path=/`;

            this.show = false;
        },

        checkCookie(cname) {
            const name = `${cname}=`;
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            // eslint-disable-next-line no-restricted-syntax
            for (const element of ca) {
                let c = element;
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return false;
        },
    },
};
</script>

<style>
    .slide-fade-enter-active {
        transition: all 0.3s ease-out;
    }

    .slide-fade-leave-active {
        transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
        transform: translateY(20px);
        opacity: 0;
    }
</style>
